import { EmblaOptionsType } from "embla-carousel";
import EmblaCarousel from "@components/emblacarousel/EmblaCarousel";
import { Lock, Search } from "lucide-react";
import IconPVA from "@icons/IconPVA";
import IconReceitaBX from "@icons/IconReceitaBX";
import UtilServices from "@services/UtilServices";
import { useEffect, useState } from "react";

const apps = [
  {
    nome: "EFD",
    icone: <IconPVA color2={"#3B82F6"} />,
    className: "bg-blue-500/100 text-white text-xs",
  },
  {
    nome: "Receita BX",
    icone: <IconReceitaBX />,
    className: "bg-green-500/100 text-white text-xs",
  },
  {
    nome: "IBS CBS",
    icone: <Search />,
    className: "bg-yellow-500/100 text-white text-xs",
  },
];

const OPTIONS: EmblaOptionsType = { loop: true };
const SLIDES = apps.map((_, index) => index);

export const AppsLogin = () => {
  const [id, setId] = useState<number>();

  const handleClick = (index: number) => {
    if ([0, 1].includes(index)) {
      UtilServices.setStorage("idsistema_redirect", "1");
    }
    if ([2].includes(index)) {
      UtilServices.setStorage("idsistema_redirect", "2");
    }

    setId(index);
  };

  useEffect(() => {
    if (["1"].includes(UtilServices.getStorage("idsistema_redirect"))) {
      setId(0);
    }
    if (["2"].includes(UtilServices.getStorage("idsistema_redirect"))) {
      setId(2);
    }
  }, []);

  return (
    <EmblaCarousel
      slides={SLIDES}
      options={OPTIONS}
      dot={false}
      renderSlide={(index) => {
        const app = apps[index];

        return (
          <div
            onClick={() => handleClick(index)}
            className={`cursor-pointer opacity-50 flex flex-col items-center justify-center rounded-lg w-[65px] h-[65px] 
              ${app.className}
              ${id === index ? "opacity-100 w-[70px] h-[70px]" : ""}`}
          >
            {app.icone}
            <span className="mt-2">{app.nome}</span>
          </div>
        );
      }}
    />
  );
};
